import React from 'react';
import styled from 'styled-components';

const Input = styled.input`
  padding: 10px;
  width: 15%;
  font-size: 1rem;
  margin-bottom: 20px;
  border-radius: 8px;
`;

const DatePicker = ({ value, onChange }) => {
  return <Input type="date" value={value} onChange={onChange} />;
};

export default DatePicker;
